class ReadMoreText extends HTMLElement {
  connectedCallback() {
    this.content = this.querySelector('.read-more__content');
    this.toggle = this.querySelector('.read-more__toggle');
    this.expanded = false;
    this.clampedHeight = this.content.offsetHeight;

    if (this.content.scrollHeight <= this.clampedHeight) return;

    this.toggle.hidden = false;
    this.toggle.addEventListener('click', () => this.handleToggle());
  }

  handleToggle() {
    const duration = Theme?.config?.motionReduced ? 0 : 300;

    if (this.expanded) {
      this.collapse(duration);
    } else {
      this.expand(duration);
    }

    this.expanded = !this.expanded;
    this.querySelector('.read-more__more').hidden = this.expanded;
    this.querySelector('.read-more__less').hidden = !this.expanded;
  }

  expand(duration) {
    const fullHeight = this.content.scrollHeight;
    this.content.style.maxHeight = `${this.clampedHeight}px`;

    requestAnimationFrame(() => {
      this.content.style.transition = duration ? `max-height ${duration}ms ease` : '';
      this.content.style.maxHeight = `${fullHeight}px`;

      if (duration) {
        this.content.addEventListener('transitionend', () => {
          this.content.style.transition = '';
        }, { once: true });
      }
    });
  }

  collapse(duration) {
    const currentHeight = this.content.scrollHeight;
    this.content.style.maxHeight = `${currentHeight}px`;
    this.content.style.transition = '';

    requestAnimationFrame(() => {
      this.content.style.transition = duration ? `max-height ${duration}ms ease` : '';
      this.content.style.maxHeight = `${this.clampedHeight}px`;

      if (duration) {
        this.content.addEventListener('transitionend', () => {
          this.content.style.maxHeight = '';
          this.content.style.transition = '';
        }, { once: true });
      } else {
        this.content.style.maxHeight = '';
      }
    });
  }
}

customElements.define('read-more-text', ReadMoreText);
